import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";
import { useIntl } from "react-intl";

import {
    JiraOverlayTemplate,
    JPDOverlayTemplate
} from "@/components/signup/layouts/product-overlay-template";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext, useLoggedInHasJira } from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";

import { WelcomeBackHeading } from "../../../loom/components";

export const LoggedInJpdExistingUser = () => {
    const { ref, inView } = useInView();
    const isLoggedInHasJira = useLoggedInHasJira();

    useFeatureExposed("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [inView],
        metadata: {
            hasJira: isLoggedInHasJira
        }
    });

    if (isLoggedInHasJira) {
        return (
            <div ref={ref}>
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            </div>
        );
    } else {
        return (
            <div ref={ref}>
                <JPDOverlayTemplate size="sm">
                    <Content />
                </JPDOverlayTemplate>
            </div>
        );
    }
};

const Content = () => {
    const {
        user: { name }
    } = useUserContext();

    const { formatMessage } = useIntl();

    return (
        <>
            <h1 css={headerCss}>
                <WelcomeBackHeading name={name} />
            </h1>
            <p css={subheadingCss}>
                {formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage:
                        "Sites are shared spaces to organize work, teams, and projects."
                })}
            </p>
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subheadingCss = css({
    margin: "16px 0 16px 0",
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: 16
});

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
